import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { SuiModalService, ModalSize } from '@richardlt/ng2-semantic-ui';

import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { DeactivateWalletModal } from '../../../modals';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
import { ro } from 'date-fns/locale';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';

interface IHeaders {
  field?: string;
  label?: string;
  type?: string;
  choices?: any[];
  op?: string;
  data?: any;
}

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss'],
})
export class AccountsComponent implements OnInit, OnDestroy {
  filter = new AppFilter({
    sidx: 'walletCreatedDate',
    sord: 'desc',
    _search: false,
  });
  baseUrl = environment.API_SERVER;
  status = 'ACITVE';
  pending: boolean = true;
  success: any;
  error: any;
  showDeactivateButton = false;

  actionPerformed = [
    {
      optionId: 'ACTIVE',
      optionName: 'ACTIVE',
    },
    {
      optionId: 'PENDING',
      optionName: 'PENDING',
    },
    {
      optionId: 'INACTIVE',
      optionName: 'INACTIVE',
    },
  ];

  public headers: IHeaders[] = [
    {
      field: 'currencyShortName',
      label: 'Currency',
      type: 'text',
      op: 'cn',
      data: '',
    },
    // {
    //   field: 'balance',
    //   label: 'Balance',
    //   type: 'text',
    //   op: 'cn',
    //   data: '',
    // },
    // {
    //   field: 'bookBalance',
    //   label: 'Book Balance',
    //   type: 'text',
    //   op: 'cn',
    //   data: '',
    // },
    {
      field: 'status',
      label: 'Status',
      type: 'select',
      op: 'eq',
      choices: this.actionPerformed,
      data: '',
    },
  ];

  searchFilter = {
    groupOp: 'or',
    rules: [
      {
        field: 'currencyShortName',
        op: 'cn',
        data: '',
      },
      // {
      //   field: 'balance',
      //   op: 'cn',
      //   data: '',
      // },
      // {
      //   field: 'bookBalance',
      //   op: 'cn',
      //   data: '',
      // },

      {
        field: 'status',
        op: 'eq',
        data: '',
      },
    ],
  };

  balances: any = [];
  totalItems: number = this.balances.length;
  rows: number = 10;
  currentPage: number = 1;
  maxSize: number = 5;
  user;

  transactionStatus;
  transactionMessage;
  transactionRrr;

  message: string;

  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private eWalletServices: EwalletService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.user['totpEnabled']
      ? this.init()
      : this.router.navigate(['/contractor/wallet']);
  }
  init() {
    console.log('Init...');
    this.getBalances(this.filter);
    this.getWalletDetails();

    // handle route query parameters
    this.transactionStatus = this.route.snapshot.queryParamMap.get('status');
    this.transactionRrr = this.route.snapshot.queryParams['rrr'];

    this.message = this.route.snapshot.queryParamMap.get('message');
    this.transactionRrr
      ? console.log(this.transactionStatus, this.message, this.transactionRrr)
      : '';

    // if(this.transactionStatus == true){
    if (this.message) {
      this.transactionMessage = `
                        Your payment using the RRR - ${this.addHyphen(
                          this.transactionRrr
                        )} has been successfully processed
                        and will appear in your account once it is approved by the Administrator.
                        To review the status of your payment, please
                      `;
    }
  }
  goBack() {
    this.location.back();
  }

  addHyphen(str: string): string {
    let formatted;
    if (str != null) {
      formatted = str.match(/.{1,4}/g).join('-');
    }
    return formatted;
  }

  checkPaymentStatus() {
    this.router.navigate(['/contractor/payment/list']);
  }

  searchRecords(search) {
    console.log(search);
    if (search) {
      let searchFilter = this.searchFilter;
      searchFilter.rules.forEach((rule) => {
        rule.data = search;
      });
      this.filter._search = true;
      this.filter.sidx = 'walletCreatedDate';
      this.filter.filters = JSON.stringify(this.searchFilter);
      console.log(this.searchFilter);
    } else {
      let filter = new AppFilter({
        sidx: 'walletCreatedDate',
        sord: 'desc',
        _search: false,
      });
      this.filter.filters = {};
      this.filter = filter;
    }
    this.currentPage = 1;
    this.filter.page = this.currentPage;
    this.getBalances(this.filter);
  }

  sortRecords(order: string) {
    this.filter.sord = order == 'desc' ? 'desc' : 'asc';
    this.getBalances(this.filter);
  }

  advancedSearch(search) {
    if (search) {
      this.filter = search;
      this.filter._search = true;
      this.filter.sidx = 'walletCreatedDate';
      this.filter.filters = JSON.stringify(search);
    } else {
      let filter = new AppFilter({
        sidx: 'walletCreatedDate',
        sord: 'asc',
        _search: false,
      });
      this.filter.filters = {};
      this.filter = filter;
    }
    this.currentPage = 1;
    this.filter.page = this.currentPage;

    this.getBalances(this.filter);
    console.log(this.filter);
  }

  cancelAd() {
    this.filter = new AppFilter({
      page: this.currentPage,
      rows: this.rows,
      sidx: 'walletCreatedDate',
    });
    this.getBalances(this.filter);
  }

  nextPage(page: number) {
    this.currentPage = page;
    this.filter.page = page;
    this.getBalances(this.filter);
  }

  onDisplayRecords(row) {
    this.rows = row;
    this.filter.rows = row;
    this.getBalances(this.filter);
  }

  getBalances(params: any) {
    // Get Balances
    const user = JSON.parse(localStorage.getItem('user'));
    const nccId = user.organizationId.jpaContractor.nccId;
    this.pending = true;
    this.eWalletServices
      .getBalances({
        params: {
          ...params,
          nccId: nccId,
        },
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.balances = res['rows'];
          this.totalItems = res['records'];
          this.showDeactivateButton = this.balances.every(
            (balance: any) => balance?.balance == 0
          );
          this.balances = this.balances.map((balance) => {
            if (balance.currencyShortName.includes('DOLLAR')) {
              localStorage.setItem('usDollarId', balance.currencyId);
            }
            balance.activeBankDetails = JSON.parse(balance.activeBankDetails);
            return balance;
          });
        },
        (err) => {
          this.error = err.error;
          this.pending = false;
        }
      );
  }

  getWalletDetails() {
    this.error = null;
    const organization = JSON.parse(
      window.localStorage.getItem('organization')
    );
    this.pending = true;
    this.eWalletServices
      .getWalletDetails({
        nccId: organization.jpaContractor.nccId,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          if (res.ewalletActivated) {
            this.status = 'ACTIVE';
          } else {
            this.status = 'INACTIVE';
            this.router.navigate(['/contractor/wallet']);
          }
          if (
            new Date(res.deactivationRequestedBate) >
            new Date(res.ewalletActivationDate)
          ) {
            this.status = 'PENDING';
          }
          this.getBalances(this.filter);
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  deactivateWallet() {
    this.modalService
      .open(new DeactivateWalletModal(this.balances))
      .onApprove(() => {
        this.modalService
          .open(
            new ConfirmModal(
              'Deactivate Wallet',
              'Your deactivation request has been submitted successfully. Once approved, your eWallet will be fully deactivated.',
              ModalSize.Tiny,
              'Okay',
              ''
            )
          )
          .onApprove(() => {
            this.init();
          });
      });
  }
}
